import { lazy } from "react"
import {
  CROP_PLANTING_EVENT_LIST_VIEW,
  CROP_PLANTING_EVENT_VIEW,
  NEW_CROP_PLANTING_EVENT_VIEW,
} from "./route-list"
import DesktopSidebarLayout from "@/layouts/desktop-sidebar-layout/desktop-sidebar-layout.tsx"
import NoMenuLayout from "@/layouts/no-menu-layout/no-menu-layout.tsx"

const AllCropPlantingEventsView = lazy(
  () =>
    import(
      "@/features/events/crop-planting-events/views/all-crop-planting-events-view/all-crop-planting-events-view.tsx"
    ),
)

const CropPlantingEventView = lazy(
  () =>
    import(
      "@/features/events/crop-planting-events/views/crop-planting-event-view/crop-planting-event-view.tsx"
    ),
)

const NewCropPlantingEventView = lazy(
  () =>
    import(
      "@/features/events/crop-planting-events/views/new-crop-planting-event-view/new-crop-planting-event-view.tsx"
    ),
)

const cropPlantingEventsRoutes = [
  {
    path: CROP_PLANTING_EVENT_LIST_VIEW,
    element: <AllCropPlantingEventsView />,
  },
  {
    path: NEW_CROP_PLANTING_EVENT_VIEW,
    element: <NewCropPlantingEventView />,
  },
  {
    path: CROP_PLANTING_EVENT_VIEW,
    element: <CropPlantingEventView />,
  },
]

const DESKTOP_ROUTES = [
  {
    element: <DesktopSidebarLayout />,
    children: cropPlantingEventsRoutes,
  },
]

const MOBILE_NO_MENU_LAYOUT_CROP_PLANTING_EVENTS_ROUTES = [
  {
    element: <NoMenuLayout />,
    children: cropPlantingEventsRoutes,
  },
]

export const getCropPlantingEventsRoutes = (isDesktop: boolean) => {
  if (isDesktop) {
    return DESKTOP_ROUTES
  }
  return MOBILE_NO_MENU_LAYOUT_CROP_PLANTING_EVENTS_ROUTES
}
